/**
 * @generated SignedSource<<bd866069c132e18681858ee52466c919>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Video_Video$data = {
  readonly enableSubtitles: boolean;
  readonly id: string;
  readonly optimizedUrl: string;
  readonly posterUrl: string | null | undefined;
  readonly url: string;
  readonly " $fragmentType": "Video_Video";
};
export type Video_Video$key = {
  readonly " $data"?: Video_Video$data;
  readonly " $fragmentSpreads": FragmentRefs<"Video_Video">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Video_Video",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "optimizedUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "posterUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableSubtitles",
      "storageKey": null
    }
  ],
  "type": "Video",
  "abstractKey": null
};

(node as any).hash = "4be882854eb1b6786a60b51e8a370bad";

export default node;
